import {collection, query, where, getCountFromServer, getDocs, sum, getAggregateFromServer,} from 'firebase/firestore'
import {fire} from "../../../fire";
import {obtenerColeccionQuery} from "../obtenerColeccionQuery";

export const sumarPropiedadColeccionWheres = ({coleccion, propiedad, wheres}) => {
    // 0 es enero


    let col = collection(fire, coleccion)

    const q = query(col, ...wheres);

    return new Promise(resolve => {
        getAggregateFromServer(q, {suma: sum(propiedad)}).then((dox) => {
            return resolve({res: true, data: dox.data().suma})
        }).catch((err) => {
            console.log(err)
            return resolve({res: false, data: 0})
        })
    })


}